import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

interface IResponse {
    success: boolean;
}

export async function revokeDataSourceAccess(dataSourceId: number) {
    const params = { data_source: dataSourceId.toString() };

    try {
        const { data } = await axios.get<IResponse>(Endpoints.User.RevokeDataSourceAccess, { params });

        return data.success;
    } catch (error) {
        return false;
    }
}
